/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class ConditionService extends services.DataService<Wars.Domain.Model.Conditions.Condition> {

        constructor(injectedBreeze: typeof breeze, $q: angular.IQService, private $http: angular.IHttpService) {
            super(injectedBreeze, $q);
        }

        public getAllConditions(processConfigId: string): ng.IPromise<Wars.Domain.Model.Conditions.Condition[]> {
            const query = this.breezeModule.EntityQuery
                .from("Conditions")
                .where('processConfiguration_id', '==', processConfigId)
                .orderBy("name");

            return this.executeQuery(query);
        }

        public getAllConditionsEagerLoadExpression(processConfigurationId: string): ng.IPromise<Wars.Domain.Model.Conditions.Condition[]> {
            const query = this.breezeModule.EntityQuery
                .from("Conditions")
                .where('processConfiguration_id', '==', processConfigurationId)
                .expand('expression')
                .orderBy("name");

            return this.executeQuery(query);
        }

        public getCondition(id: string): ng.IPromise<Wars.Domain.Model.Conditions.Condition> {
            return this.fetchById(id, "Condition");
        }

        public createFieldExpression(): Wars.Domain.Model.Conditions.TreeItemExpression {
            var newFieldExpression = this.createNewEntity<Wars.Domain.Model.Conditions.TreeItemExpression>("TreeItemToTreeItemExpression");
            newFieldExpression.expressionType = Wars.Domain.Model.Codes.Enums.ExpressionType.TreeItemToTreeItem;
            return newFieldExpression;
        }

        public createValueExpression(): Wars.Domain.Model.Conditions.TreeItemToConstantExpression {
            var fieldToConstantExpression = this.createNewEntity<Wars.Domain.Model.Conditions.TreeItemToConstantExpression>("TreeItemToConstantExpression");
            fieldToConstantExpression.expressionType = Wars.Domain.Model.Codes.Enums.ExpressionType.TreeItemToConstant;
            return fieldToConstantExpression;
        }

        public createGroupExpression(): Wars.Domain.Model.Conditions.GroupExpression {
            var groupExpression = this.createNewEntity<Wars.Domain.Model.Conditions.GroupExpression>("GroupExpression");
            groupExpression.expressionType = Wars.Domain.Model.Codes.Enums.ExpressionType.Group;
            groupExpression.isAnd = false;
            return groupExpression;
        }

        public createStepExpression(): Wars.Domain.Model.Conditions.FormStepExpression {
            var formStepExpression = this.createNewEntity<Wars.Domain.Model.Conditions.FormStepExpression>("FormStepExpression");
            formStepExpression.expressionType = Wars.Domain.Model.Codes.Enums.ExpressionType.Step;
            return formStepExpression;
        }

        public createOperationParameterSet(): Wars.Domain.Model.OperationParameterSet {
            return this.createNewEntity<Wars.Domain.Model.OperationParameterSet>("OperationParameterSet");
        }

        public createOperationParameter(set:Wars.Domain.Model.OperationParameterSet): Wars.Domain.Model.OperationParameter {
            let param=this.createNewEntity<Wars.Domain.Model.OperationParameter>("OperationParameter");
            param.myOperationParameterSet = set;

            return param;
        }

        public getOperationSetExpanded(id):angular.IPromise<Wars.Domain.Model.OperationParameterSet> {
            var expand = "operationParameters.treeItem.schemaProperty, " +
                "operationParameters.treeItem.calculation, " +
                "operationParameters.treeItem.condition, " +
                "operationParameters.treeItem.constantValue, " +
                "operationParameters.treeItem.formStep, " +
                "operationParameters.treeItem.claim";

            const query = this.breezeModule.EntityQuery
                .from("OperationParameterSets")
                .where('id', '==', id)
                .expand(expand);

            return (this.executeQuery(query)) as any;
        }

        public executeConditions(id:string, conditionIds: string[]) : angular.IPromise<Wars.Domain.Model.Dtos.ConditionResultDto[]> {
            var d = this.$q.defer();
            this.$http.post('./api/condition/' + id + '/ExecuteConditions/', conditionIds)
                .then(result => {
                    d.resolve(result.data);
                });

            return d.promise;
        }

        public executeAssignConditions(
            processId: string,
            claimUniqueId: string,
            assignUserId: string,
            assignmentRights: Wars.Domain.Model.Dtos.AssignmentRightsDto[]): angular.IPromise<Wars.Domain.Model.Dtos.AssignmentCheckDto[]> {
            var d = this.$q.defer();
            this.$http.post('./api/condition/ExecuteAssignConditions/' + processId + '/' + claimUniqueId + '/' + assignUserId, assignmentRights)
                .then(result => {
                    d.resolve(result.data);
                });

            return d.promise;
        }

        public executeUnAssigConditions(
            processId: string,
            assignmentId: string,
            assignmentRights: Wars.Domain.Model.Dtos.AssignmentRightsDto[]): angular.IPromise<Wars.Domain.Model.Dtos.AssignmentCheckDto[]>
        {
            var d = this.$q.defer();
            this.$http.post('./api/condition/ExecuteUnAssignConditions/' + processId + '/' + assignmentId, assignmentRights)
                .then(result => {
                    d.resolve(result.data);
                });

            return d.promise;
        }

        public executeCondition(id: string, conditionId: string): angular.IPromise<Wars.Domain.Model.Dtos.ConditionResultDto> {
            var d = this.$q.defer();
            this.$http.post('./api/condition/' + id + '/ExecuteCondition/' + conditionId, {})
                .then(result => {
                    d.resolve(result.data);
                });

            return d.promise;
        }
    }
}

warsApp.registerService('ConditionService', ['breeze', '$q','$http']);